<template>
    <div class="card block">
        <header class="card-header">
            <p class="card-header-title">
                {{ teamName }}
            </p>
            <button class="card-header-icon" aria-label="more options">
                <span class="icon">
                    <i class="fas fa-angle-down" aria-hidden="true"></i>
                </span>
            </button>
        </header>
        <DeliveryItem v-for="delivery in getDeliveriesForTeam" :key="delivery.beneficiary_id" :name="delivery.full_name"
            :dryBag="delivery.dry_bag" :quantity="delivery.quantity" :unit="delivery.unit" :block="delivery.block"
            :street="delivery.street" :completed="delivery.completed" :completedAtTime="delivery.completed_at_time"
            :age="delivery.age" :deliverySort="delivery.delivery_sort" :beneficiaryID="delivery.beneficiary_id"
            :fdID="this.fdID" :fdStatus="this.fdStatus" :status="delivery.status" :selfCollection="delivery.self_collection"
            :drivingDelivery="delivery.driving_delivery" :deliveryNotes="delivery.notes"
            :deliveryTeam="delivery.delivery_team" :drivingTeams="this.drivingTeams" :walkingTeams="this.walkingTeams"
            :bagStatus="delivery.bag_status" :consecutiveUndeliveredCount="delivery.consecutive_undelivered_count"
            :dietaryRequirement="delivery.dietary_requirement" :adminNotes="delivery.delivery_notes">
        </DeliveryItem>
    </div>
</template>

<script>
import DeliveryItem from './DeliveryItem.vue';
export default {
    components: {
        DeliveryItem
    },
    props: ['fdID', 'fdStatus', 'teamName', 'drivingTeams', 'walkingTeams'],
    computed: {
        getDeliveriesForTeam() {
            return this.$store.getters['delivery/getDeliveriesForTeam'](this.teamName);
        }
    }
}
</script>